angular.module('angus.controllers').controller('fdsServiceMarginSettingsCtrl', [
    '$scope', '_', 'constantsService',
    function($scope, _, constantsService) {

        'use strict';

        $scope.periodIndicators      = constantsService.servicePeriodIndicators.enums;
    }
]);
